const gatewaySource = '_6976';
const toolsSource = '_6311';
export const isRegularAccessory = (
    { source }: { source: string },
) => ![gatewaySource, toolsSource].includes(source);
export const isGatewayAccessory = (
    { source }: { source: string },
) => gatewaySource === source;
export const isToolsAccessory = (
    { source }: { source: string },
) => toolsSource === source;
